// extracted by mini-css-extract-plugin
export default {"cardBody":"Card_cardBody__Baq7-","image":"Card_image__ZlhbW","text":"Card_text__a7tLC","list":"Card_list__n04Bk","btn":"Card_btn__GDQIk"};